export default __webpack_public_path__ + "74ada0788636dec30e89b22d1d21e4f0.png";